"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gaeta": {
    "04bbd16a": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "40-remi": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f736c60": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "areanuta": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb6b3f81": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "ariana": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "73e9dfb6": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "fontania": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "339a19e2": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "san-vito": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1776996": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agostino": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fbced8cc": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "skipSearch": false
    }],
    "spiagge-serapo": [{
      "hkey": "0cfccd92",
      "slug": "gaeta",
      "name": "Gaeta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;